module.exports = __webpack_public_path__ + "media/images/landings/promotion_4/img_campaign_txt-2b0c505f9727da9b26d4b499d56dddd9.png";